import { render, staticRenderFns } from "./TheHeaderDropdownAccnt.vue?vue&type=template&id=5a5dcf0c&scoped=true"
import script from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownAccnt.vue?vue&type=style&index=0&id=5a5dcf0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5dcf0c",
  null
  
)

export default component.exports